






















import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import getIntegration from "@/payments/integrations";
import { IntegrationType } from "@/payments/integrations/const";
import EmptyContent from "@/components/EmptyContent";
import ModalView from "@/components/ModalView";

export default defineComponent({
  name: "ChoosePaymentSystem",
  components: { EmptyContent, ModalView },
  props: {
    paymentSystemsPublic: { type: Array as () => PaymentSystemPublic[], required: true },
    isSubscription: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const unsupportedPaymentSystemsTypes = ref<string[]>([]);
    const availableSystems = computed(() =>
      props.paymentSystemsPublic
        .map(system => {
          const { name, logo, type, subscribe } = getIntegration(system);
          if (!name) {
            unsupportedPaymentSystemsTypes.value.push(system.type);
          }
          if (props.isSubscription && !subscribe) {
            unsupportedPaymentSystemsTypes.value.push(system.type);
          }
          return { system, name, logo, isCrypto: type === IntegrationType.CRYPTO };
        })
        .filter(s => !unsupportedPaymentSystemsTypes.value.includes(s.system.type))
    );

    watch(
      availableSystems,
      () => {
        if (availableSystems.value.length === 1) emit("chooseSystem", availableSystems.value[0].system);
      },
      { immediate: true }
    );

    return {
      availableSystems,
    };
  },
});
